import { mdiHomeOutline } from '@mdi/js'

export default [
  {
    title: 'Inicio',
    icon: mdiHomeOutline,
    to: 'home',
  },
]
